<template>
<div class="hello">
    <h1 class="hi"> <b class="label">happyzuri.ch</b><br> Quick Emoji suverys for the digital and real world 😃</h1>
    <p class="lead">Ask a question and share them with a link or print out as a QR-Code to share in a space. </p>
    <!-- <p class="lead"><b>Happy Zurich </b>does this by allowing people to create poster, digital polls, stickers and sharing them throughout the city. The platform should be seen as a movement by the people for the people – creating a dialog for a better city of tomorrow.</p> -->
    <!-- <h3> <b class="label">Step 01 </b> <br> Think of a space that either gave you joy or great grieve.</h3> -->
    <div>
        <input placeholder="The space 📍" v-model="newTarget" type="text">
        <input placeholder="Your Question ❓" v-model="newTarget2" type="text">
        <button class="prim" style="" :disabled="newTarget == 0 || newTarget2 == 0" v-on:click="submit()">
        ✅
      </button>
      <br>
      <small v-if="newTarget == 0 || newTarget2 == 0">Please fill out the space and question.</small>
        <!-- <h3> <b class="label">Step 02 </b> <br> Try to formulate your reaction into an opinion or question.</h3> -->

        <!-- <h3> <b class="label">Step 03 </b> <br>Click the "Participate" button and print it out. Wait for the reactions. </h3> -->


        <br>


    </div>
</div>
</template>

<script>
import debounce from 'debounce'
import {
    db
} from '../firebase';

export default {
    name: 'Start',
    props: {
        msg: String,
    },
    data() {
        return {
            letters: [],
            lettersLength: [],
            newTarget: '',
            newTarget2: '',
            isTyping: false,
        }
    },
    firestore() {

    },
    mounted: function() {
        // this.findLocation() //method1 will execute at pageload
    },
    methods: {
        submit: function() {
            var convert = this.newTarget.split(' ').join('_');
            var convert2 = this.newTarget2.split(' ').join('_');

            this.$router.push("/where/" + convert + "/" + convert2)

        },

        findLocation: function() {
            this.$getLocation()
                .then(coordinates => {
                    this.$store.commit('setLocation', coordinates)
                });
        },
    },
    watch: {

        size: function(val) {
            this.$store.commit('setSize', val)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
    max-width: 800px;
    display: inline-block;
    padding-top: 3em;
    text-align: left;
}

.hi {
  color: rgba(0,0,0, 0.8);
  font-size: 6vh;
}

input {
    min-width: 200px;
    font-size: 20px;
    margin-right: 12px;
    padding: 12px;
    border-radius: 4px;
    color: black;
    outline: none;
    margin-top: 1em;
    border: none;
}

.lead {
    font-size: 3vh;
}

.prim {
    margin-left: 0;
    background: black;
    color: white;
}
.prim:hover{
  background-color: white;
}
.prim:disabled{
  opacity: 0.6;
}

.label {
    /* text-transform: uppercase; */
    font-size: 3vh;
    color: rgba(0,0,0, 0.5);
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>
